import { Fragment } from 'react'
import { TextLink } from '../TextLink'

export const CreatorsLinkList = ({ creators }: CreatorsLinkListProps) => {
  if (!creators || creators.length === 0) {
    return null
  }

  const list = creators.filter(Boolean)

  return (
    <span>
      {list.map((creator, index) => (
        <Fragment key={creator?.urlStub ?? `creator-${index}`}>
          {index > 0 && (
            <span>{index === list.length - 1 ? ' and ' : ', '}</span>
          )}
          <TextLink href={`/magician/${creator?.urlStub}`} className="text-gray-500!">
            {creator?.name}
          </TextLink>
        </Fragment>
      ))}
    </span>
  )
}

interface CreatorsLinkListProps {
  creators?:
    | ({
        urlStub?: string | null
        name?: string | null
      } | null)[]
    | null
    | undefined
}
